import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const Offers = {
  list: () => api.get("/offers").then((r) => r.data),
  create: (data) => api.post("/admin/offers", data).then((r) => r.data),
  update: (id, data) => api.put(`/admin/offers/${id}`, data).then((r) => r.data),
  remove: (id) => api.delete(`/admin/offers/${id}`).then((r) => r.data),
};

export const Restaurant = {
  get: () => api.get("/restaurant").then((r) => r.data),
  update: (data) => api.put("/admin/restaurant", data).then((r) => r.data),
};

export const Menu = {
  get: () => api.get("/menu").then((r) => r.data),
  replace: (categories) =>
    api.put("/admin/menu", { categories }).then((r) => r.data),
};

export const Auth = {
  me: () => api.get("/auth/me").then((r) => r.data),
  exchange: (session_id) =>
    api.post("/auth/google/session", { session_id }).then((r) => r.data),
  logout: () => api.post("/auth/logout").then((r) => r.data),
};
